var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table',_vm._b({attrs:{"show-header":false}},'el-table',_vm.$attrs,false),[_c('el-table-column',{attrs:{"prop":"service"}}),_c('el-table-column',{attrs:{"prop":"price"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }